import React, { createContext, useContext } from "react";

const translations = {
  pl: {
    events: "EVENTY",
    culture: "KULTURA",
    food: "GASTRONOMIA",
    learning: "NAUKA",
    museums: "MUZEA",
    theatres: "TEATRY",
    cinemas: "KINA",
    monuments: "ZABYTKI",
    other: "INNE",
    restaurants: "RESTAURACJE",
    fastFood: "FAST FOODY",
    cafes: "KAWIARNIE",
    desserts: "DESERY",
    libraries: "BIBLIOTEKI",
    bookstores: "KSIĘGARNIE",
    courses: "KURSY",
    fairs: "TARGI I KIERMASZE",
    search: "SZUKAJ",
    contact: "KONTAKT",
    account: "KONTO",
    homeHeadline: "Miejsca, ludzie i wydarzenia",
    homeHeadlineEmphasis: "w zasięgu ręki.",
    homeIntro: "Inspiracje, które warto mieć na swojej mapie.",
    nearDays: "Na najbliższe dni",
    interestingEvents: "Ciekawe eventy",
    weekend: "Na weekend i dalej",
    interestingPlaces: "Ciekawe miejsca",
    important: "Ważne",
    information: "Informacje",
    calendar: "Z kalendarza",
    upcomingCelebrations: "Nadchodzące uroczystości",
    reading: "Do poczytania",
    latestArticles: "Najnowsze artykuły",
    readMore: "Czytaj dalej",
    allArticles: "Wszystkie artykuły",
    browseYourWay: "Szukaj po swojemu",
    discoverByCategory: "Odkryj według kategorii",
    empty: "Trochę tu pusto...",
    changeIt: "możesz to zmienić",
    suggestPlace: "Znasz inne ciekawe miejsce? Kliknij i wyślij nam formularz",
    suggestEvent: "Znasz inne ciekawe wydarzenie? Kliknij i wyślij nam formularz",
    cultureDescription: "Muzea, teatry, kina i zabytki.",
    foodDescription: "Restauracje, kawiarnie i desery.",
    learningDescription: "Biblioteki, księgarnie i kursy.",
    eventsDescription: "Sprawdź, co dzieje się w mieście.",
    footerDescription: "Portal powstał pod koniec 2023 roku, w szczególności dla osób, które nie znają miasta, ale również dla wszystkich, którzy chcieliby na bieżąco wiedzieć co dzieje się w ich mieście.",
    links: "Linki",
    home: "Strona główna",
    about: "O nas",
    articles: "Artykuły",
    login: "Logowanie",
    register: "Rejestracja",
    downloadApp: "Pobierz aplikacje",
    availableSoon: "(dostępne wkrótce)",
    rights: "Wszelkie prawa zastrzeżone.",
    privacyPolicy: "Polityka Prywatności",
    cookies: "Użycie plików cookies",
    categoryReadMore: "Dowiedz się więcej o kategorii",
    breadcrumbLabel: "Okruszki nawigacyjne",
    categoryGuide: "PRZEWODNIK PO KATEGORII",
    backToCategory: "Wróć do kategorii",
    contactKicker: "NAPISZ DO NAS",
    contactIntro: "Masz pytanie, chcesz zgłosić miejsce lub zauważyłeś problem? Wybierz najwygodniejszy sposób kontaktu.",
    contactDetails: "Dane kontaktowe",
    contactEmail: "E-mail",
    contactOffice: "Siedziba",
    contactTaxId: "NIP",
    contactMap: "Zobacz na mapie",
    contactFormTitle: "Wyślij wiadomość",
    contactFormIntro: "Zaloguj się i opisz sprawę. Odpowiemy na podany adres e-mail.",
    contactLoginPrompt: "Zaloguj się, aby wysłać wiadomość przez formularz.",
    contactVerifyPrompt: "Potwierdź adres e-mail przez link weryfikacyjny, aby wysłać wiadomość.",
    contactLogin: "Zaloguj się",
    contactSubject: "Temat",
    contactMessage: "Wiadomość",
    contactMessagePlaceholder: "Opisz, w czym możemy pomóc...",
    contactSend: "Wyślij wiadomość",
    contactSubjectPlace: "Zgłoszenie nowego miejsca",
    contactSubjectIssue: "Błąd na stronie",
    contactSubjectOther: "Inna sprawa",
    contactFormSuccess: "Wiadomość została wysłana.",
    contactFormFailure: "Nie udało się wysłać wiadomości.",
    contactFormEmpty: "Wiadomość nie może być pusta.",
    loginKicker: "TWOJE KONTO",
    loginIntro: "Zaloguj się, aby dodawać miejsca, wysyłać wiadomości i korzystać z funkcji konta.",
    loginFormTitle: "Zaloguj się do konta",
    loginFormIntro: "Wpisz adres e-mail oraz hasło użyte podczas rejestracji.",
    password: "Hasło",
    loginSubmit: "Zaloguj się",
    forgotPassword: "Nie pamiętasz hasła?",
    noAccount: "Nie masz jeszcze konta?",
    createAccount: "Załóż konto",
    loginGoogleTitle: "Logowanie zewnętrzne",
    loginGoogleIntro: "Możesz także kontynuować przez konto Google.",
    loginWithGoogle: "Zaloguj z Google",
    loginEnterEmail: "Wpisz e-mail.",
    loginInvalidEmail: "Nieprawidłowy e-mail.",
    loginEnterPassword: "Wprowadź hasło.",
    loginInvalidCredentials: "Niepoprawny e-mail lub hasło.",
    loginBanned: "Konto zostało zablokowane. Powód: ",
    loginBannedNoReason: "nie podano",
    formGenericError: "Wystąpił błąd. Spróbuj ponownie za chwilę.",
    registerKicker: "TWOJE KONTO",
    registerIntro: "Załóż konto, aby dodawać miejsca, wysyłać wiadomości i korzystać z funkcji społeczności.",
    registerFormTitle: "Utwórz konto",
    username: "Nazwa użytkownika",
    repeatPassword: "Powtórz hasło",
    registerSubmit: "Załóż konto",
    haveAccount: "Masz już konto?",
    registerGoogleTitle: "Rejestracja zewnętrzna",
    registerGoogleIntro: "Możesz także utworzyć konto przez Google.",
    registerWithGoogle: "Zarejestruj z Google",
    emailPlaceholder: "np. nazwa@domena.pl",
    usernamePlaceholder: "Wpisz nazwę użytkownika",
    passwordPlaceholder: "Wpisz hasło",
    repeatPasswordPlaceholder: "Powtórz hasło",
    registerUsernameTaken: "Użytkownik o podanej nazwie istnieje. Wpisz inną nazwę użytkownika.",
    registerEmailTaken: "Użytkownik o podanym e-mailu istnieje. Wpisz inny adres.",
    registerBannedName: "Nazwa użytkownika zawiera niedozwolone słowo.",
    registerEnterUsername: "Wpisz nazwę użytkownika.",
    registerUsernameLimit: "Nazwa użytkownika może mieć maksymalnie 30 znaków.",
    registerPasswordMinimum: "Hasło musi zawierać co najmniej 8 znaków.",
    registerPasswordLimit: "Hasło może mieć maksymalnie 100 znaków.",
    registerPasswordMismatch: "Hasła nie są takie same.",
    registerCaptchaError: "Potwierdź reCAPTCHA. Jeśli jej nie widzisz, odśwież stronę.",
    sortBy: "Sortuj według",
    resultsCount: "Liczba wyników",
    changeCardView: "Zmień widok kart",
    pagination: "Paginacja wyników",
    previous: "Poprzednie",
    next: "Następne",
    viewPlace: "Zobacz miejsce",
    viewEvent: "Zobacz wydarzenie",
    cardOpenToday: "Czynne dzisiaj",
    openingHours: "Godziny otwarcia",
    closed: "nieczynne",
    cardClosed: "zamknięte",
    cardNotOpenToday: "nieczynne",
    allDay: "całą dobę",
    churchHours: "według mszy i nabożeństw",
    scheduleHours: "według repertuaru",
    cardAddress: "Adres",
    cardDistance: "Odległość",
    cardDate: "Data",
    cardTime: "Godzina",
  },
  en: {
    events: "EVENTS",
    culture: "CULTURE",
    food: "FOOD",
    learning: "LEARNING",
    museums: "MUSEUMS",
    theatres: "THEATRES",
    cinemas: "CINEMAS",
    monuments: "LANDMARKS",
    other: "OTHER",
    restaurants: "RESTAURANTS",
    fastFood: "FAST FOOD",
    cafes: "CAFES",
    desserts: "DESSERTS",
    libraries: "LIBRARIES",
    bookstores: "BOOKSTORES",
    courses: "COURSES",
    fairs: "FAIRS AND MARKETS",
    search: "SEARCH",
    contact: "CONTACT",
    account: "ACCOUNT",
    homeHeadline: "Places, people and events",
    homeHeadlineEmphasis: "within reach.",
    homeIntro: "Inspiration worth adding to your map.",
    nearDays: "For the days ahead",
    interestingEvents: "Interesting events",
    weekend: "For the weekend and beyond",
    interestingPlaces: "Interesting places",
    important: "Important",
    information: "Information",
    calendar: "From the calendar",
    upcomingCelebrations: "Upcoming celebrations",
    reading: "Worth reading",
    latestArticles: "Latest articles",
    readMore: "Read more",
    allArticles: "All articles",
    browseYourWay: "Browse your way",
    discoverByCategory: "Discover by category",
    empty: "It is a little empty here...",
    changeIt: "you can change that",
    suggestPlace: "Know another interesting place? Click and send us a form",
    suggestEvent: "Know another interesting event? Click and send us a form",
    cultureDescription: "Museums, theatres, cinemas and landmarks.",
    foodDescription: "Restaurants, cafes and desserts.",
    learningDescription: "Libraries, bookstores and courses.",
    eventsDescription: "See what is happening in the city.",
    footerDescription: "The portal was created at the end of 2023, especially for people who do not know the city, and for everyone who wants to keep up with what is happening in their city.",
    links: "links",
    home: "Home",
    about: "About us",
    articles: "Articles",
    login: "Log in",
    register: "Register",
    downloadApp: "Download the app",
    availableSoon: "(coming soon)",
    rights: "All rights reserved.",
    privacyPolicy: "Privacy policy",
    cookies: "Cookie usage",
    categoryReadMore: "Learn more about this category",
    breadcrumbLabel: "Breadcrumb navigation",
    categoryGuide: "CATEGORY GUIDE",
    backToCategory: "Back to the category",
    contactKicker: "GET IN TOUCH",
    contactIntro: "Have a question, want to suggest a place or spotted a problem? Choose the most convenient way to contact us.",
    contactDetails: "Contact details",
    contactEmail: "Email",
    contactOffice: "Office",
    contactTaxId: "Tax ID",
    contactMap: "View on map",
    contactFormTitle: "Send a message",
    contactFormIntro: "Sign in and describe your request. We will reply to the email address provided.",
    contactLoginPrompt: "Sign in to send a message using the form.",
    contactVerifyPrompt: "Confirm your email address using the verification link to send a message.",
    contactLogin: "Sign in",
    contactSubject: "Subject",
    contactMessage: "Message",
    contactMessagePlaceholder: "Tell us how we can help...",
    contactSend: "Send message",
    contactSubjectPlace: "Suggest a new place",
    contactSubjectIssue: "Report a site issue",
    contactSubjectOther: "Other matter",
    contactFormSuccess: "Your message has been sent.",
    contactFormFailure: "We could not send your message.",
    contactFormEmpty: "Your message cannot be empty.",
    loginKicker: "YOUR ACCOUNT",
    loginIntro: "Sign in to suggest places, send messages and use account features.",
    loginFormTitle: "Sign in to your account",
    loginFormIntro: "Enter the email address and password used during registration.",
    password: "Password",
    loginSubmit: "Sign in",
    forgotPassword: "Forgot your password?",
    noAccount: "Do not have an account yet?",
    createAccount: "Create an account",
    loginGoogleTitle: "External sign-in",
    loginGoogleIntro: "You can also continue with your Google account.",
    loginWithGoogle: "Sign in with Google",
    loginEnterEmail: "Enter your email.",
    loginInvalidEmail: "Enter a valid email address.",
    loginEnterPassword: "Enter your password.",
    loginInvalidCredentials: "Incorrect email or password.",
    loginBanned: "This account has been suspended. Reason: ",
    loginBannedNoReason: "not given",
    formGenericError: "Something went wrong. Please try again in a moment.",
    registerKicker: "YOUR ACCOUNT",
    registerIntro: "Create an account to suggest places, send messages and use community features.",
    registerFormTitle: "Create an account",
    username: "Username",
    repeatPassword: "Repeat password",
    registerSubmit: "Create an account",
    haveAccount: "Already have an account?",
    registerGoogleTitle: "External registration",
    registerGoogleIntro: "You can also create an account with Google.",
    registerWithGoogle: "Register with Google",
    emailPlaceholder: "e.g. name@example.com",
    usernamePlaceholder: "Enter a username",
    passwordPlaceholder: "Enter your password",
    repeatPasswordPlaceholder: "Repeat your password",
    registerUsernameTaken: "That username is already in use. Enter a different username.",
    registerEmailTaken: "That email address is already in use. Enter a different address.",
    registerBannedName: "The username contains a prohibited word.",
    registerEnterUsername: "Enter a username.",
    registerUsernameLimit: "A username can contain up to 30 characters.",
    registerPasswordMinimum: "Your password must contain at least 8 characters.",
    registerPasswordLimit: "Your password can contain up to 100 characters.",
    registerPasswordMismatch: "The passwords do not match.",
    registerCaptchaError: "Confirm the reCAPTCHA. If it is not visible, refresh the page.",
    sortBy: "Sort by",
    resultsCount: "Results per page",
    changeCardView: "Change card view",
    pagination: "Results pagination",
    previous: "Previous",
    next: "Next",
    viewPlace: "View place",
    viewEvent: "View event",
    cardOpenToday: "Open today",
    openingHours: "Opening hours",
    closed: "closed",
    cardClosed: "closed",
    cardNotOpenToday: "not open today",
    allDay: "24 hours",
    churchHours: "according to masses and services",
    scheduleHours: "according to schedule",
    cardAddress: "Address",
    cardDistance: "Distance",
    cardDate: "Date",
    cardTime: "Time",
  },
};

const LanguageContext = createContext({ language: "pl", t: (key) => key });

export function LanguageProvider({ language, children }) {
  const t = (key) => translations[language]?.[key] ?? translations.pl[key] ?? key;

  return <LanguageContext.Provider value={{ language, t }}>{children}</LanguageContext.Provider>;
}

export function useLanguage() {
  return useContext(LanguageContext);
}
